// 活动管理-互动玩法活动类型
export const useActivityTypeList = () => {
  const activityTypeList = [
    {
      value: 1,
      label: "日历签到",
    },
    {
      value: 4,
      label: "关注店铺有礼",
    },
    {
      value: 17,
      label: "首单专享礼",
    },
    {
      value: 16,
      label: "下单有礼",
    },
    {
      value: 19,
      label: "下单抽奖",
    },
    {
      value: 18,
      label: "复购有礼",
    },
    {
      value: 34,
      label: "加购有礼",
    },
    {
      value: 36,
      label: "打榜有礼",
    },
    {
      value: 27,
      label: "预售有礼",
    },
    {
      value: 28,
      label: "预售抽奖",
    },
    {
      value: 8,
      label: "幸运抽奖",
    },
    {
      value: 7,
      label: "完善信息有礼",
    },
    {
      value: 20,
      label: "评价有礼",
    },
    {
      value: 3,
      label: "每日限时抢",
    },
    {
      value: 22,
      label: "天降红包雨",
    },
    {
      value: 23,
      label: "欢乐娃娃机",
    },
    {
      value: 24,
      label: "大家来找茬",
    },
    {
      value: 5,
      label: "邀请开卡有礼",
    },
    {
      value: 6,
      label: "邀请关注有礼",
    },
    {
      value: 21,
      label: "裂变神券",
    },
    {
      value: 31,
      label: "超级裂变券",
    },
    {
      value: 39,
      label: "生日有礼",
    },
    {
      value: 41,
      label: "晒单有礼",
    },
    {
      value: 43,
      label: "N元锁权",
    },
    {
      value: 44,
      label: "会员升级礼",
    },
    {
      value: 46,
      label: "满额有礼",
    },
    {
      value: 45,
      label: "锁权有礼",
    },
    {
      value: 47,
      label: "调查问卷",
    },
    {
      value: 48,
      label: "定时开奖",
    },
    {
      value: 50,
      label: "情书贺卡",
    },
    {
      value: 51,
      label: "0元试用",
    },
    {
      value: 52,
      label: "试用回购礼",
    },
    {
      value: 53,
      label: "购物打卡",
    },
    {
      value: 62,
      label: "集卡有礼",
    },
    {
      value: 64,
      label: "组队瓜分奖品",
    },
    {
      value: 65,
      label: "粉丝打卡",
    },
    {
      value: 66,
      label: "入会有礼",
    },
    {
      value: 67,
      label: "销售打榜",
    },
    {
      value: 68,
      label: "会员成长计划",
    },
    {
      value: 69,
      label: "拼团砍价",
    },
    {
      value: 71,
      label: "趣味游戏",
    },
    {
      value: 76,
      label: "时光许愿池",
    },
    {
      value: 77,
      label: "购物车锦鲤",
    },
    {
      value: 78,
      label: "打包一口价",
    },
    {
      value: 79,
      label: "盖楼有礼",
    },
    {
      value: 80,
      label: "小红书晒单礼",
    },
    {
      value: 81,
      label: "集分冲榜",
    },
    {
      value: 82,
      label: "粉丝集分应援",
    },
    {
      value: 83,
      label: "晒图PK",
    },
    {
      value: 84,
      label: "日历打卡",
    },
    {
      value: 85,
      label: "百变趣答",
    },
    {
      value: 87,
      label: "答题导购",
    },
    {
      value: 89,
      label: "积分兑换优惠券",
    },
    // {
    //   value: 86,
    //   label: "AI趣味答题",
    // },
  ];
  return activityTypeList;
};
// 官方/云起标签-互动引入付款/互动引入交易-活动类型
export const useInteractActivityTypeList = () => {
  const activityTypeList = [
    { label: "预售抽奖", value: 28 },
    { label: "预售有礼", value: 27 },
    { label: "首单专享礼", value: 17 },
    { label: "复购有礼", value: 18 },
    { label: "下单有礼", value: 16 },
    { label: "下单抽奖", value: 19 },
    { label: "晒单有礼", value: 41 },
    { label: "会员升级礼", value: 44 },
    { label: "满额有礼", value: 46 },
    { label: "锁权有礼", value: 45 },
    { label: "开卡礼包", value: 13 },
    { label: "店铺礼包", value: 14 },
    { label: "店铺礼包（千人千面）", value: 15 },
    { label: "情书贺卡", value: 50 },
    { label: "定时开奖", value: 48 },
    { label: "0元试用", value: 51 },
    { label: "购物打卡", value: 53 },
    { label: "集卡有礼", value: 62 },
    { label: "BI店铺礼包", value: 63 },
    { label: "组队瓜分奖品", value: 64 },
    { label: "粉丝打卡", value: 65 },
    { label: "入会有礼", value: 66 },
    { label: "销售打榜", value: 67 },
    { label: "会员成长计划", value: 68 },
    { label: "拼团砍价", value: 69 },
    { label: "趣味游戏", value: 71 },
    { label: "关注礼包", value: 74 },
    { label: "加购礼包", value: 75 },
    {
      value: 76,
      label: "时光许愿池",
    },
    { label: "购物车锦鲤", value: 77 },
    { label: "打包一口价", value: 78 },
    { label: "盖楼有礼", value: 79 },
    { label: "小红书晒单礼", value: 80 },
    { label: "集分冲榜", value: 81 },
    { label: "粉丝集分应援", value: 82 },
    { label: "晒图PK", value: 83 },
    { label: "日历打卡", value: 84 },
    { label: "百变趣答", value: 85 },
    { label: "AI趣味答题", value: 86 },
    { label: "答题导购", value: 87 },
    { label: "积分兑换优惠券", value: 89 },
  ];
  return activityTypeList;
};

// 官方/云起标签-互动开卡-活动类型
export const useInteractOpenCardTypeList = () => {
  const activityTypeList = [
    { label: "签到赢好礼", value: 1 },
    { label: "每日限时抢", value: 3 },
    { label: "关注店铺有礼", value: 4 },
    { label: "完善信息有礼", value: 7 },
    { label: "加购有礼", value: 34 },
    { label: "预售有礼", value: 27 },
    { label: "预售抽奖", value: 28 },
    { label: "首单专享礼", value: 17 },
    { label: "复购有礼", value: 18 },
    { label: "下单有礼", value: 16 },
    { label: "下单抽奖", value: 19 },
    { label: "评价有礼", value: 20 },
    { label: "邀请开卡有礼", value: 5 },
    { label: "裂变神券", value: 21 },
    { label: "幸运抽奖", value: 8 },
    { label: "天降红包雨", value: 22 },
    { label: "欢乐娃娃机", value: 23 },
    { label: "大家来找茬", value: 24 },
    { label: "刮刮乐", value: 26 },
    { label: "0元试用", value: 33 },
    { label: "积分兑换优惠券", value: 10 },
    { label: "积分兑换实物", value: 9 },
    { label: "积分兑换京豆", value: 29 },
    { label: "积分兑换E卡", value: 30 },
    { label: "积分兑换红包", value: 38 },
    { label: "生日有礼", value: 39 },
    { label: "晒单有礼", value: 41 },
    { label: "会员升级礼", value: 44 },
    { label: "满额有礼", value: 46 },
    { label: "锁权有礼", value: 45 },
    { label: "情书贺卡", value: 50 },
    { label: "调查问卷", value: 47 },
    { label: "定时开奖", value: 48 },
    { label: "0元试用", value: 51 },
    { label: "试用回购礼", value: 52 },
    { label: "购物打卡", value: 53 },
    { label: "集卡有礼", value: 62 },
    { label: "BI店铺礼包", value: 63 },
    { label: "组队瓜分奖品", value: 64 },
    { label: "粉丝打卡", value: 65 },
    { label: "入会有礼", value: 66 },
    { label: "销售打榜", value: 67 },
    { label: "会员成长计划", value: 68 },
    { label: "拼团砍价", value: 69 },
    { label: "趣味游戏", value: 71 },
    { label: "关注礼包", value: 74 },
    { label: "加购礼包", value: 75 },
    {
      value: 76,
      label: "时光许愿池",
    },
    { label: "购物车锦鲤", value: 77 },
    { label: "打包一口价", value: 78 },
    { label: "盖楼有礼", value: 79 },
    { label: "小红书晒单礼", value: 80 },
    { label: "集分冲榜", value: 81 },
    { label: "粉丝集分应援", value: 82 },
    { label: "晒图PK", value: 83 },
    { label: "日历打卡", value: 84 },
    { label: "百变趣答", value: 85 },
    { label: "AI趣味答题", value: 86, permission: "hide:hdLabel:AIFUNNYQUIZ" },
    { label: "答题导购", value: 87 },
    { label: "积分兑换优惠券", value: 89 },
  ];
  return activityTypeList;
};
// 官方/云起标签-参与指定活动-活动类型
export const useInteractJoinActivityTypeList = () => {
  const activityTypeList = [
    { label: "签到赢好礼", value: 1 },
    { label: "每日限时抢", value: 3 },
    { label: "关注店铺有礼", value: 4 },
    { label: "完善信息有礼", value: 7 },
    { label: "加购有礼", value: 34 },
    { label: "开卡礼包", value: 13 },
    { label: "店铺礼包", value: 14 },
    { label: "店铺礼包（千人千面）", value: 15 },
    { label: "预售有礼", value: 27 },
    { label: "预售抽奖", value: 28 },
    { label: "首单专享礼", value: 17 },
    { label: "复购有礼", value: 18 },
    { label: "下单有礼", value: 16 },
    { label: "下单抽奖", value: 19 },
    { label: "评价有礼", value: 20 },
    { label: "邀请开卡有礼", value: 5 },
    { label: "邀请关注有礼", value: 6 },
    { label: "裂变神券", value: 21 },
    { label: "超级裂变券", value: 31 },
    { label: "幸运抽奖", value: 8 },
    { label: "天降红包雨", value: 22 },
    { label: "欢乐娃娃机", value: 23 },
    { label: "大家来找茬", value: 24 },
    { label: "刮刮乐", value: 26 },
    { label: "0元试用", value: 33 },
    { label: "积分兑换优惠券", value: 10 },
    { label: "积分兑换实物", value: 9 },
    { label: "积分兑换京豆", value: 29 },
    { label: "积分兑换E卡", value: 30 },
    { label: "积分兑换红包", value: 38 },
    { label: "生日有礼", value: 39 },
    { label: "晒单有礼", value: 41 },
    { label: "会员升级礼", value: 44 },
    { label: "满额有礼", value: 46 },
    { label: "锁权有礼", value: 45 },
    { label: "N元锁权", value: 43 },
    { label: "情书贺卡", value: 50 },
    { label: "专属赠品礼", value: 40, permission: "hide:hdLabel:a2Give" },
    {
      label: "派样回购礼(随单发)",
      value: 42,
      permission: "hide:hdLabel:promoActivity",
    },
    {
      label: "派样回购礼(定制)",
      value: 37,
      permission: "hide:hdLabel:sendReBuy",
    },
    { label: "积分锁权(定制)", value: 35, permission: "hide:hdLabel:lock" },
    { label: "调查问卷", value: 47 },
    { label: "定时开奖", value: 48 },
    { label: "0元试用", value: 51 },
    { label: "试用回购礼", value: 52 },
    { label: "购物打卡", value: 53 },
    { label: "积分加钱购", value: 55 },
    { label: "兑换爱奇艺会员", value: 58 },
    { label: "兑换PLUS会员", value: 59 },
    { label: "兑换礼品卡", value: 60 },
    { label: "兑换百度网盘", value: 61 },
    { label: "集卡有礼", value: 62 },
    { label: "BI店铺礼包", value: 63 },
    { label: "组队瓜分奖品", value: 64 },
    { label: "粉丝打卡", value: 65 },
    { label: "入会有礼", value: 66 },
    { label: "销售打榜", value: 67 },
    { label: "会员成长计划", value: 68 },
    { label: "拼团砍价", value: 69 },
    { label: "趣味游戏", value: 71 },
    { label: "AI测肤", value: 72 },
    { label: "关注礼包", value: 74 },
    { label: "加购礼包", value: 75 },
    {
      value: 76,
      label: "时光许愿池",
    },
    { label: "购物车锦鲤", value: 77 },
    { label: "打包一口价", value: 78 },
    { label: "盖楼有礼", value: 79 },
    { label: "小红书晒单礼", value: 80 },
    { label: "集分冲榜", value: 81 },
    { label: "粉丝集分应援", value: 82 },
    { label: "晒图PK", value: 83 },
    { label: "日历打卡", value: 84 },
    { label: "百变趣答", value: 85 },
    { label: "AI趣味答题", value: 86, permission: "hide:hdLabel:AIFUNNYQUIZ" },
    { label: "答题导购", value: 87 },
    { label: "积分兑换优惠券", value: 89 },
  ];
  return activityTypeList;
};

// 生成唯一uuid钩子函数（参考 node_modules/uuid 库 v4 实现）
export const useGenerateUUID = () => {
  // 1. 取加密安全随机源：优先 getRandomValues，兼容 IE 的 msCrypto
  var getRandomValues =
    (typeof crypto !== "undefined" &&
      crypto.getRandomValues &&
      crypto.getRandomValues.bind(crypto)) ||
    (typeof msCrypto !== "undefined" &&
      msCrypto.getRandomValues &&
      msCrypto.getRandomValues.bind(msCrypto));
  var rnds = new Uint8Array(16);
  if (getRandomValues) {
    getRandomValues(rnds);
  } else {
    // 无加密 API 时降级为 Math.random（uuid 库同款兜底逻辑）
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
    }
  }
  // 2. 写入版本位(v4)与变体位(RFC 4122)，同 uuid 库
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;
  // 3. 16 字节转 XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX 格式
  var byteToHex = [];
  for (var j = 0; j < 256; ++j) {
    byteToHex[j] = (j + 0x100).toString(16).substr(1);
  }
  var bth = byteToHex;
  return [
    bth[rnds[0]],
    bth[rnds[1]],
    bth[rnds[2]],
    bth[rnds[3]],
    "-",
    bth[rnds[4]],
    bth[rnds[5]],
    "-",
    bth[rnds[6]],
    bth[rnds[7]],
    "-",
    bth[rnds[8]],
    bth[rnds[9]],
    "-",
    bth[rnds[10]],
    bth[rnds[11]],
    bth[rnds[12]],
    bth[rnds[13]],
    bth[rnds[14]],
    bth[rnds[15]],
  ].join("");
};
